/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_No_Templates_FoundInputs */



/**
* | output |
* | --- |
* | "No Event Templates Found" |
*
* @param {Event_Templates_No_Templates_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_no_templates_found = /** @type {((inputs?: Event_Templates_No_Templates_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_No_Templates_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun modele d'evenement trouve")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ereignisvorlagen gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun modello di evento trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Шаблоны мероприятий не найдены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron plantillas de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到活动模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテンプレートが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई इवेंट टेम्प्लेट नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum modelo de evento encontrado")
	return /** @type {LocalizedString} */ ("No Event Templates Found")
});